import { render, staticRenderFns } from "./SnapshotItem.vue?vue&type=template&id=dae3fd74&"
import script from "./SnapshotItem.vue?vue&type=script&lang=ts&"
export * from "./SnapshotItem.vue?vue&type=script&lang=ts&"
import style0 from "./SnapshotItem.vue?vue&type=style&index=0&id=dae3fd74&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports